module.exports = __webpack_public_path__ + "img/jimny.decc0ae0.png";